import { useEffect, useState } from "react";

import { FormGroup } from "@blueprintjs/core";
import { Link } from "react-router";

import { Box, Flex } from "@/components/layout/flexbox";
import { PaginationButton } from "@/components/pieces/form/PaginationButton";
import { Avatar } from "@/components/pieces/users/Avatar";
import { NonNullableArrayItem } from "@/types/utils";
import { StatsMember } from "@/types/workspaces";

type Coach = NonNullableArrayItem<NonNullable<StatsMember["user"]>["coaches"]>;

interface CoachListProps {
  coaches: Coach[];
}

export function CoachList({ coaches }: CoachListProps) {
  const [page, setPage] = useState(1);
  const pageSize = 3;
  const totalPage = coaches.length / pageSize;
  const index = (page - 1) * pageSize;

  useEffect(() => {
    if (coaches) setPage(1);
  }, [coaches]);

  const onNext = () => {
    setPage((currentPage) => {
      return currentPage < totalPage ? currentPage + 1 : currentPage;
    });
  };
  const onPrev = () => {
    setPage((currentPage) => {
      return currentPage > 1 ? currentPage - 1 : 1;
    });
  };

  return (
    <FormGroup
      style={{ marginTop: 10, marginBottom: 0 }}
      label={
        <Flex justifyContent="space-between" alignItems="flex-end">
          <b style={{ fontSize: 20 }}>Current Coaches</b>
          <Flex>
            <Box mx={2}>
              <PaginationButton
                icon="chevron-left"
                disabled={page <= 1}
                onClick={() => onPrev()}
                style={{ paddingLeft: 10, paddingRight: 10 }}
              />
            </Box>
            <Box>
              <PaginationButton
                icon="chevron-right"
                disabled={page >= totalPage}
                onClick={() => onNext()}
                style={{ paddingLeft: 10, paddingRight: 10 }}
              />
            </Box>
          </Flex>
        </Flex>
      }
    >
      <Flex css={{ marginRight: -16 }}>
        {coaches.length === 0 && (
          <Box fontStyle="italic" color="#778397">
            None yet
          </Box>
        )}
        {coaches.slice(index, index + pageSize).map((coach) => {
          const { agentProfile } = coach || {};
          const { coachSlug } = agentProfile || {};
          return (
            <Box
              key={`coach-item-${coach.id}`}
              p={16}
              css={{
                borderRadius: 6,
                position: "relative",
                marginRight: 16,
                width: "33%",
              }}
              className="bas"
            >
              <Flex
                flexDirection="column"
                alignItems="center"
                css={{ textAlign: "center" }}
              >
                <Link target="_blank" to={`/@${coachSlug}`}>
                  <Avatar user={coach} size={60} />
                  <Box mt={3} fontWeight={600} fontSize={16} textAlign="center">
                    {coach.name}
                  </Box>
                </Link>
              </Flex>
            </Box>
          );
        })}
      </Flex>
    </FormGroup>
  );
}
